import { searchFund, searchStock, searchIndice } from '../../utils/search'

export const getGlobalSearchFund = (fundList, searchQuery) => {
  const search = searchFund(searchQuery, fundList)
  let results = {
    score: 0,
    data: []
  }
  if (search.length > 0) {
    results.score = search[0].score
    search.map(item => {
      results.data.push(item.item)
    })
  }
  return results
}

export const getGlobalSearchStock = (stockList, searchQuery) => {
  const search = searchStock(searchQuery, stockList)
  let results = {
    score: 0,
    data: []
  }
  if (search.length > 0) {
    results.score = search[0].score
    search.map(item => {
      results.data.push(item.item)
    })
  }
  return results
}

export const getGlobalSearchIndice = (indiceList, searchQuery) => {
  const search = searchIndice(searchQuery, indiceList)
  let results = {
    score: 0,
    data: []
  }

  if (search.length > 0) {
    results.score = search[0].score
    search.map(item => {
      results.data.push(item.item)
    })
  }
  return results
}

